import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.div`
	border-top: 8px solid ${({ theme }) => theme.colors.primary.medium};

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		min-width: 400px;
	}
`;

export const Content = styled.div`
	padding: 8px 24px;
`;

export const ChildrenContainer = styled.div`
	padding: 32px 0;
`;

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 64px;
`;

export const Title = styled.span`
	${({ theme }) => theme.typography.headlines.h5};

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		${({ theme }) => theme.typography.headlines.h4};
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ButtonContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
`;
